var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c("div", [
        _vm.datasets.length + _vm.distributions.length > 0
          ? _c("div", [
              _vm.datasets.length > 0
                ? _c("table", { staticClass: "table table-striped" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.datasets, function (ds) {
                        return _c("tr", { key: ds.id }, [
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.objectUrl + ds.id,
                                  target: "_blank",
                                  title: "Open data set in new tab",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(ds.name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("p", {
                              domProps: { innerHTML: _vm._s(ds.definition) },
                            }),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.distributions.length > 0
                ? _c("table", { staticClass: "table table-striped" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.distributions, function (dist) {
                        return _c("tr", { key: dist.id }, [
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.objectUrl + dist.id,
                                  target: "_blank",
                                  title: "Open distribution in new tab",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(dist.name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("p", {
                              domProps: { innerHTML: _vm._s(dist.definition) },
                            }),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ])
          : _c("strong", [_vm._v(" No items are included in this data set ")]),
      ])
    : _c("Loading")
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Included Data Sets")]),
      ]),
      _vm._v(" "),
      _c("tr", { staticClass: "sticky-header" }, [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Definition")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Included Distributions"),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", { staticClass: "sticky-header" }, [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Definition")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }